import React, { useEffect, FC } from 'react';
import type { Location } from 'react-router-dom';

import type { PostHogConfig, PostHog } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

export interface AnalyticsProps {
  children: React.ReactNode;
  apiKey: string | undefined;
  apiHost: string | undefined;
  uiHost: string | undefined;
  options?: Partial<PostHogConfig>;
  enabled: boolean;
}

export const AnalyticsProvider: React.FC<AnalyticsProps> = ({
  enabled,
  apiKey,
  apiHost,
  uiHost,
  children,
  options = {},
}) => {
  if (!enabled || !apiKey || !apiHost) {
    return <>{children}</>;
  }

  const composedOptions = {
    api_host: apiHost,
    ui_host: uiHost,
    ...options,
  };

  return (
    <PostHogProvider apiKey={apiKey} options={composedOptions}>
      {children}
    </PostHogProvider>
  );
};

interface PostHogPageViewProps {
  children: React.ReactNode;
  enabled?: boolean;
  posthog?: PostHog;
  location?: Location;
}

export const AnalyticsPageView: FC<PostHogPageViewProps> = ({
  children,
  enabled,
  posthog,
  location,
}) => {
  useEffect(() => {
    if (enabled && posthog) {
      posthog.capture('$pageview', {
        $current_url: window.location.href,
      });
    }
  }, [location, posthog, enabled]);

  return <>{children}</>;
};
